import myBreadcrumb from './index.vue'
 function install(vue){
  vue.component('my-breadcrumb',myBreadcrumb)
}
export default {
  install
}